<script setup lang="ts">
import type { ContentRootProps } from '@fondof-ui/components/content/types'
import clsx from 'clsx'

const props = withDefaults(defineProps<ContentRootProps>(), {
  alignment: 'left',
  disableHyphens: false,
})
</script>

<template>
  <div
    :class="
      clsx(
        {
          'text-center': props.alignment === 'center',
          'text-left': props.alignment === 'left',
          'text-right': props.alignment === 'right',
          'hyphens-auto': !props.disableHyphens,
        },
        props.class
      )
    "
    :style="{
      'hyphenate-limit-chars': '8 3',
    }"
  >
    <slot />
  </div>
</template>
